import React, { useEffect } from 'react';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';

export const Name = ({ inputModel }) => {
  const MAX_LENGTH = 100;

  useEffect(() => {}, []);

  return (
    <React.Fragment>
      <TextInput
        id="w9upload-name-field"
        aria-label="type here to Enter a Name"
        maxLength={MAX_LENGTH}
        validators={{
          required: 'Name is required.',
        }}
        isClearable
        name={`name-input-${uniqueId()}`}
        autoComplete="none"
        model={inputModel}
        label="Name (as shown on your income tax return)"
      />
    </React.Fragment>
  );
};

Name.propTypes = {
  inputModel: PropTypes.string.isRequired,
};

Name.defaultProps = {};
